import { ReactNode } from 'react';

import { ListFooter } from './ListFooter';

type Props = {
  header?: ReactNode;
  showFooter?: boolean;
  children?: ReactNode;
};

export const ListWrapper = ({ header, showFooter, children }: Props) => {
  return (
    <div className="flex flex-col gap-6 xl:gap-8">
      {header ? header : null}
      {children}
      {showFooter && <ListFooter />}
    </div>
  );
};
